module.exports = __webpack_public_path__ + "static/media/xing.888a6b31.png";